import { Controller } from "@hotwired/stimulus"

export default class ScrollToElementController extends Controller {
  static targets = ["scroll"]
  static values = {
    block: { type: String, default: "center" },
    scrollOnConnect: { type: Boolean, default: false },
  }

  connect() {
    if (this.scrollOnConnectValue) {
      this.scroll()
    }
  }

  scroll() {
    this.scrollTarget.scrollIntoView({ behavior: "smooth" })
  }

  scrollToIdentifier({ detail: { id }, params: { behavior = "smooth" } }) {
    this.element
      .querySelector(`[data-scroll-to-element-identifier="${id}"]`)
      .scrollIntoView({
        behavior,
        block: this.blockValue,
      })
  }
}
